// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__1-p-8","contentWrapper":"style_contentWrapper__1jDF1","hidden":"style_hidden__BBrsW","content":"style_content__UPP4R","arrow":"style_arrow__wIouD"};